import { instanceBo } from "../utils/axios.create";
import { ValidationAgentEntry } from "../domain/validationAgent.interface";
import { ValidationType } from "../domain/event.interface";

/**
 * The validation-agent catalog — SIMS-8223.
 *
 * 🔴 An empty array is a legitimate answer, not a failure. The backend returns
 * `[]` when no agent supports the event's validation type, and the picker
 * renders that as a disabled control with an explanation (AC9). Turning an
 * empty result into an error here would make that state unreachable.
 */
const getValidationAgents = async (
	validationType?: ValidationType,
): Promise<ValidationAgentEntry[]> =>
	instanceBo
		.get("/validation-agents", {
			params: validationType ? { validationType } : undefined,
		})
		.then((res) => (res.data.body ?? []) as ValidationAgentEntry[])
		.catch((err) => Promise.reject(err.response?.data ?? err));

export const validationAgentService = { getValidationAgents };
